// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import type { OperationOptions } from "@azure-rest/core-client";

/** Optional parameters. */
export interface BlobInventoryPoliciesListOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface BlobInventoryPoliciesDeleteOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface BlobInventoryPoliciesCreateOrUpdateOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface BlobInventoryPoliciesGetOptionalParams extends OperationOptions {}
